import React from 'react';
import PaginatedTable from '../../commonComponents/util/PaginatedTable';
import CampaignListApplicationsTableRow from './CampaignListApplicationsTableRow';


export default class CampaignListApplicationsTable extends React.Component {

    constructor(props) {
        super(props);
        this.getTableRow = this.getTableRow.bind(this);
    }

    getTableRow(applicationData) {
        const update = {success: this.props.success === true};
        return <CampaignListApplicationsTableRow 
                    key={applicationData.applicationId} 
                    tableStatus={this.props.applicationStatus}
                    permissions={this.props.userPermissions}
                    userId={this.props.userId}
                    admin={this.props.admin}
                    maxAmount={this.props.maxAmount}
                    applicationData={applicationData}
                    updating={this.props.updating[applicationData.applicationId] === true}
                    updateError={this.props.updating.hasOwnProperty(applicationData.applicationId) &&
                         this.props.updating[applicationData.applicationId] !== true}
                    update={update}
                    updateApplication={this.props.updateApplication}
                    updateApplicationStatus={this.props.updateApplicationStatus}
                    campaignId={this.props.campaignId}
                    campaignListId={this.props.campaignListId}
                    campaignListName={this.props.campaignListName} />;
    }

    render() {
        let columns = [
            { id: 'firstName', title: 'First Name', sortable: true },
            { id: 'lastName', title: 'Last Name', sortable: true },
            { id: 'creationDate', title: 'Created Date', sortable: true },
            { id: 'status', title: 'Status', sortable: true },
            { id: 'amount', title: 'Amount', sortable: true },
            { id: 'orgEmployment', title: 'Position', sortable: false },
            { id: 'checkDate', title: 'Check Date', sortable: true },
            { id: 'checkNumber', title: 'Check Number', sortable: true }];

        return <div className="campaign-list-applications-table">
            <PaginatedTable
                name="campaign list applications"
                page={this.props.page}
                totalCount={this.props.data.totalCount}
                resultsView={this.props.resultsView}
                sort={this.props.sort}
                loading={this.props.loading}
                success={this.props.success}
                renderRow={this.getTableRow}
                columns={columns}
                records={this.props.data.records || []}
                sortData={this.props.updateTable}
                changeDataView={this.props.updateTable}
                loadData={this.props.getCampaignListApplications} />
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignListDetails/CampaignListApplicationsTable.jsx